import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const List = styled.ol`
  list-style: none;
  margin: 0;
  counter-reset: count;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  counter-increment: count;
  margin-bottom: ${tokens.spacer.x5};

  &:last-of-type {
    margin-bottom: 0;
  }

  &:before {
    content: counter(count);
    display: block;
    width: ${tokens.spacer.x3};
    height: ${tokens.spacer.x3};
    margin-right: ${tokens.spacer.x4};
    border-radius: 50%;
    background-color: ${tokens.color.neutral_100};
    color: ${tokens.color.text_default};
    ${tokens.text('subtitle2')};
    line-height: 24px;
    text-align: center;
  }
`;
